/* Fuego & Fragancia — cuestionario del ritual (PRD §9.2).

   Modelo de decisión, sin nada de azar:
   · Preguntas con rol "intention": cada respuesta lleva una clave (self-love,
     protection, …). Gana la clave más votada y se muestra su resultado.
   · Preguntas con rol "format": no puntúan. Solo eligen si la recomendación
     final es la vela, el room spray o el wax melt.

   El mismo <ff-quiz> se usa en la sección de la home y en el pop-up del hero:
   el modal no copia el cuestionario, lo MUEVE. Así no pueden desincronizarse. */

if (!customElements.get('ff-quiz')) {
  customElements.define(
    'ff-quiz',
    class FfQuiz extends HTMLElement {
      connectedCallback() {
        // connectedCallback se vuelve a ejecutar al mover el elemento al modal:
        // sin esta guarda se duplicarían los listeners en cada apertura.
        if (this.initialized) return;
        this.initialized = true;

        this.introScreen = this.querySelector('[data-screen="intro"]');
        this.questionScreens = Array.from(this.querySelectorAll('[data-screen="question"]'));
        this.resultScreens = Array.from(this.querySelectorAll('[data-screen="result"]'));
        this.answers = [];
        this.format = null;

        const startBtn = this.querySelector('[data-ff-quiz-start]');
        if (startBtn) startBtn.addEventListener('click', () => this.goToQuestion(0));

        this.questionScreens.forEach((screen, index) => {
          screen.querySelectorAll('.ff-quiz__option').forEach((option) => {
            option.addEventListener('click', () => this.answer(index, option.dataset.resultKey));
          });
          const backBtn = screen.querySelector('[data-ff-quiz-back]');
          if (backBtn) backBtn.addEventListener('click', () => this.goBack(index));
        });

        this.querySelectorAll('[data-ff-quiz-restart]').forEach((btn) => {
          btn.addEventListener('click', () => this.restart());
        });
      }

      isFormatQuestion(index) {
        const screen = this.questionScreens[index];
        return !!screen && screen.dataset.role === 'format';
      }

      showScreen(screen) {
        this.querySelectorAll('.ff-quiz__screen').forEach((s) => s.classList.remove('is-active'));
        if (!screen) return;
        screen.classList.add('is-active');

        // Dentro del modal el desplazamiento lo lleva el propio modal.
        if (this.closest('[data-ff-quiz-modal]')) {
          const slot = this.closest('.ff-quiz-modal__inner');
          if (slot) slot.scrollTop = 0;
          return;
        }

        const top = this.getBoundingClientRect().top + window.scrollY - 120;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
      }

      goToQuestion(index) {
        if (index >= this.questionScreens.length) {
          this.showResult();
          return;
        }
        this.showScreen(this.questionScreens[index]);
      }

      goBack(index) {
        this.answers = this.answers.slice(0, index);
        if (index === 0) {
          this.showScreen(this.introScreen);
        } else {
          this.goToQuestion(index - 1);
        }
      }

      answer(index, key) {
        this.answers[index] = key;
        this.goToQuestion(index + 1);
      }

      // Solo cuentan las preguntas de intención; las de formato se ignoran aquí.
      winningKey() {
        const scored = this.answers.filter((key, index) => key && !this.isFormatQuestion(index));
        const tally = {};
        scored.forEach((key) => {
          tally[key] = (tally[key] || 0) + 1;
        });

        let best = null;
        let bestCount = 0;
        // Los empates se resuelven por la respuesta dada antes, que mantiene
        // el resultado estable y predecible.
        scored.forEach((key) => {
          if (tally[key] > bestCount) {
            best = key;
            bestCount = tally[key];
          }
        });
        return best;
      }

      chosenFormat() {
        let format = null;
        this.answers.forEach((key, index) => {
          if (key && this.isFormatQuestion(index)) format = key;
        });
        return format;
      }

      showResult() {
        const key = this.winningKey();
        const match =
          this.resultScreens.find((screen) => screen.dataset.resultKey === key) || this.resultScreens[0];
        if (!match) return;

        // De todos los CTA del resultado se deja visible solo el del formato
        // elegido; si ese formato no tiene producto asignado, el de por defecto.
        const format = this.chosenFormat();
        const ctas = Array.from(match.querySelectorAll('.ff-quiz__result-cta'));
        if (ctas.length) {
          const wanted = format ? ctas.find((cta) => cta.dataset.format === format) : null;
          const fallback = ctas.find((cta) => cta.dataset.format === 'default') || ctas[0];
          const visible = wanted || fallback;
          ctas.forEach((cta) => {
            cta.hidden = cta !== visible;
          });
        }

        this.showScreen(match);
      }

      restart() {
        this.answers = [];
        this.format = null;
        this.showScreen(this.introScreen);
      }
    }
  );
}

/* ---------- Pop-up a pantalla completa ----------
   Cualquier elemento con [data-ff-open-quiz] lo abre (por ejemplo, un botón
   del hero). El cuestionario se MUEVE al modal y vuelve a su sitio al cerrar,
   así que es siempre el mismo, con los mismos ajustes. */

if (!window.ffQuizModalReady) {
  window.ffQuizModalReady = true;

  // El cuestionario vive permanentemente dentro del modal (sección estática),
  // así que abrir es solo mostrarlo y reiniciarlo. No hay que moverlo de sitio
  // ni existe una segunda copia con la que pueda desincronizarse.
  const openQuizModal = () => {
    const modal = document.querySelector('[data-ff-quiz-modal]');
    if (!modal) return;

    modal.hidden = false;
    // Un frame para que la transición de entrada tenga estado inicial.
    requestAnimationFrame(() => modal.classList.add('is-open'));
    document.body.classList.add('overflow-hidden');

    const quiz = modal.querySelector('ff-quiz');
    if (quiz && typeof quiz.restart === 'function') quiz.restart();

    const closeBtn = modal.querySelector('[data-ff-quiz-modal-close]');
    if (closeBtn) closeBtn.focus();
  };

  const closeQuizModal = () => {
    const modal = document.querySelector('[data-ff-quiz-modal]');
    if (!modal || modal.hidden) return;

    modal.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    // Se espera al final de la transición para ocultarlo del todo.
    setTimeout(() => {
      modal.hidden = true;
      const quiz = modal.querySelector('ff-quiz');
      if (quiz && typeof quiz.restart === 'function') quiz.restart();
    }, 300);
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-ff-open-quiz]')) {
      event.preventDefault();
      openQuizModal();
      return;
    }
    if (event.target.closest('[data-ff-quiz-modal-close]')) {
      closeQuizModal();
      return;
    }
    // Clic en el fondo oscurecido, fuera del panel.
    const modal = event.target.closest('[data-ff-quiz-modal]');
    if (modal && !event.target.closest('.ff-quiz-modal__inner')) closeQuizModal();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeQuizModal();
  });
}
